<div>
  <table
    class="uk-table uk-table-hover uk-table-divider"
         style="width:100%"
         datatable
         [dtOptions]="dtOptions"
         [dtTrigger]="dtTrigger"
         id="parcelListTable"
  >
    <thead>
      <tr>
        <th style="width: 10%">{{'internal_number' | translate}}</th>
        <th>{{'status' | translate}}</th>
        <th>{{'recipient_name' | translate}}</th>
        <th *ngIf="userRole < UserRole.client">{{'client' | translate}}</th>
        <th>{{'destination_city' | translate}}</th>
        <th>{{'out_number' | translate}}</th>
        <th *ngIf="userRole < UserRole.client">{{'return_number' | translate}}</th>
        <th>{{'declared_content' | translate}}</th>
        <th>{{'cash_on_delivery_value' | translate}}</th>
        <th>{{'created_at' | translate}}</th>
        <th *ngIf="userRole < UserRole.client">#</th>
      </tr>
    </thead>
    <tfoot  id="footer">
    </tfoot>
    <tbody *ngIf="parcels?.length > 0">
      <tr *ngFor="let item of parcels"
          (mouseout)="setGoToLocker(false)"
          (click)="goTo( item.internal_number )"
          [title]="userRole < UserRole.client ? item.error_message : ''"
      >
        <td (mouseup)="setGoToLocker(true)">
          <img src="{{parcelFlagUrl(item)}}" title="{{parcelCountry(item)}}">
          <kbd>{{item.internal_number}}</kbd>
        </td>
        <td>{{item.status_name}}</td>
        <td>{{item.recipient_name}}</td>
        <td *ngIf="userRole < UserRole.client"> {{item.client_name}} </td>
        <td>{{item.return_parcel ? item.source_city : item.destination_city}}</td>
        <td (mouseup)="setGoToLocker(true)">
          {{ item.buffer_number === null ? (item.out_number === '-' ? item.in_number : item.out_number) : item.buffer_number }}
        </td>
        <td *ngIf="userRole < UserRole.client"  (mouseup)="setGoToLocker(true)">
          {{item.return_number}}
        </td>
        <td>
          {{item.declared_content}}
        </td>
        <td>
          {{item.cash_on_delivery ? item.cash_on_delivery_value + ' ' + item.currency : '-'}}
        </td>
        <td>
          {{item.created_at}}
        </td>
        <td *ngIf="userRole < UserRole.client" (mouseup)="setGoToLocker(true)">
          <input class="uk-checkbox" type="checkbox" [(ngModel)]="item.selected">
        </td>
      </tr>
    </tbody>
  </table>
</div>
